export const PORTAL_REGISTRATION_PATH = '/v2/portal/register';
export const PORTAL_REGISTRATION_CONFIRM_PATH = '/v2/portal/register/confirm';
